// extracted by mini-css-extract-plugin
export default {"form":"invite-pre-join-modal_form__M57zB","note":"invite-pre-join-modal_note__LPnVJ","footer":"invite-pre-join-modal_footer__qfa71"};